import { RidesKanbanSortEnum } from "@ryde/shared";

export interface IRidesKanbanSortMenuOption {
  sort: RidesKanbanSortEnum;
  label: string;
  isSelected: boolean;
  selectHandler: () => void;
}

/** Per option: the short value shown on the button ("Sort Updated") and the full menu entry ("Updated - Z-A"). */
export const RIDES_KANBAN_SORT_LABEL_KEYS = {
  [RidesKanbanSortEnum.UpdatedDesc]: {
    selected: "ride.KANBAN_SORT.UPDATED",
    option: "ride.KANBAN_SORT.UPDATED_DESC",
  },
  [RidesKanbanSortEnum.CreatedDesc]: {
    selected: "ride.KANBAN_SORT.CREATED",
    option: "ride.KANBAN_SORT.CREATED_DESC",
  },
  [RidesKanbanSortEnum.AreaAsc]: {
    selected: "ride.KANBAN_SORT.AREA",
    option: "ride.KANBAN_SORT.AREA_ASC",
  },
} as const satisfies Record<
  RidesKanbanSortEnum,
  { selected: string; option: string }
>;
